// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3k_yD","inputWrap":"CustomTip_inputWrap__3ZH11"};